import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import BlogPost from "./pages/BlogPost";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FinancialConsulting from "./pages/FinancialConsulting";
import DynamicFavicon from "./components/DynamicFavicon";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <DynamicFavicon />
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/financial-consulting" element={<FinancialConsulting />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
